module.exports = __webpack_public_path__ + "img/IEC13805.695f383f.png";